let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("63nsF")).then(() => parcelRequire('2ap6D'));